import React from 'react';
import './IensoErrorMsg.scss'

export const IensoErrorMsg =  React.memo(({msg}) => <span className={'text-errors  ienso-error-msg'}>{msg}</span>)



